import {
  TicketsByAssignTo,
  TicketsByMonth,
  TicketsByStatuses,
} from "../models/Dashboard";
import client from "./client";

class DashboardService {
  async GetTicketByAssignTo(year: number) {
    try {
      let startOfYear = `${year}-01-01`;
      let endOfYear = `${year}-12-31`;
      let url = `/api/Dashboards/GetTicketByAssignedTo/${startOfYear}/${endOfYear}`;

      const { data } = await client.get<TicketsByAssignTo[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetOpenTicketByMonth(year: number) {
    try {
      let startOfYear = `${year}-01-01`;
      let endOfYear = `${year}-12-31`;
      let url = `/api/Dashboards/GetTicketByMonths/${startOfYear}/${endOfYear}`;

      const { data } = await client.get<TicketsByMonth[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetClosedTicketByMonth(year: number) {
    try {
      let startOfYear = `${year}-01-01`;
      let endOfYear = `${year}-12-31`;
      let url = `/api/Dashboards/GetClosedTickets/${startOfYear}/${endOfYear}`;

      const { data } = await client.get<TicketsByMonth[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetTicketByStatuses(year: number) {
    try {
      let startOfYear = `${year}-01-01`;
      let endOfYear = `${year}-12-31`;
      let url = `/api/Dashboards/GetByStatuses/${startOfYear}/${endOfYear}`;

      const { data } = await client.get<TicketsByStatuses[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetTicketsClosedToday() {
    try {
      let url = `/api/Tickets/TicketsClosedToday`;

      const { data } = await client.get(url);
      return data as number;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new DashboardService();
